/* <cr-bundle>: Bundle & Save page (2 Nov 2026, fix round 1).
   Prices: NEVER computed here. Everything shown comes from the cart engine, window.__crSheetsGift.quote(items, note), the same function the cart
   cards and the cart re-check use. The quote is for the RESULTING cart (the lines already in the cart + the ticked books that are not in it yet),
   so the number shown is the number the cart will charge. If the engine is missing, the cart cannot be read, or the shopper has their own working
   discount code in the cart (it wins over ours, like the pair card), the price is hidden and the page says "See your price in the cart".
   Add to cart: same steps as the cart's "Make it a pair" card: queue -> add the missing variants -> cart note cr_offer_added -> engine run ->
   check the cart total equals the quote (retry) -> go to the cart. A book counts as "already in the cart" only when the SAME VARIANT is there. */
if (!customElements.get('cr-bundle')) {
  customElements.define('cr-bundle', class CrBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.fmt = 'paper';
      this.sel = [];
      this.editionName = {};
      this.cart = undefined; // undefined = not read yet, null = could not be read, object = the cart
      this.cards = Array.from(this.querySelectorAll('.cr-bcard')).map((el) => {
        const parse = (a) => { try { return JSON.parse(el.getAttribute(a) || '[]'); } catch (e) { return []; } };
        return { el, handle: el.getAttribute('data-handle'), title: el.getAttribute('data-title'), paper: parse('data-paper'), pdf: parse('data-pdf') };
      });
      this.q = (s) => this.querySelector(s);
      this.cartUrl = this.getAttribute('data-cart-url') || '/cart';
      this.addBtn = this.q('[data-add]');
      this.addLabel = this.getAttribute('data-button-label') || this.addBtn.textContent;
      this.cards.forEach((c) => {
        c.btn = c.el.querySelector('[data-toggle]');
        c.price = c.el.querySelector('[data-price]');
        c.old = c.el.querySelector('[data-old]');
        c.select = c.el.querySelector('[data-edition]');
        c.btn.addEventListener('click', () => this.toggle(c));
        c.select.addEventListener('change', () => { this.resetState(); const list = this.variants(c); const x = list[Number(c.select.value)]; if (x) this.editionName[c.handle] = x.t; this.render(); });
      });
      this.querySelectorAll('[data-format]').forEach((b) => b.addEventListener('click', () => { this.resetState(); this.fmt = b.getAttribute('data-format'); this.render(); }));
      this.q('[data-clear]').addEventListener('click', () => { this.resetState(); this.sel = []; this.render(); });
      this.addBtn.addEventListener('click', () => { if (this._goCart) { window.location.href = this.cartUrl; } else { this.addToCart(); } });
      // coming back with the Back button (page restored from the browser cache): reset the button and read the cart again
      window.addEventListener('pageshow', (e) => { if (e.persisted) { this._busy = false; this._goCart = false; this.addBtn.textContent = this.addLabel; this.showError(''); this.loadCart(); } });
      this.render();
      this.loadCart();
    }
    loadCart() {
      return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then((c) => { this.cart = c; }, () => { this.cart = null; })
        .then(() => this.render());
    }
    money(cents) {
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    }
    variants(c) { return this.fmt === 'pdf' ? c.pdf : c.paper; }
    variantOf(c) {
      const list = this.variants(c);
      if (!list.length) return null;
      const name = this.editionName[c.handle];
      const hit = name !== undefined ? list.find((x) => x.t === name) : null;
      return hit || list[0];
    }
    // leaves the "Go to cart" state (after a failed discount check) as soon as the shopper changes anything
    resetState() {
      if (this._goCart) { this._goCart = false; this.addBtn.textContent = this.addLabel; }
      this.showError('');
    }
    toggle(c) {
      this.resetState();
      const i = this.sel.indexOf(c.handle);
      if (i === -1) { if (this.variantOf(c)) this.sel.push(c.handle); } else this.sel.splice(i, 1);
      this.render();
    }
    engine() { const g = window.__crSheetsGift; return g && typeof g.quote === 'function' ? g : null; }
    // lines already in the cart (not the free sheets line)
    cartLines() {
      const g = window.__crSheetsGift;
      const gift = g ? g.gift : 0;
      return ((this.cart && this.cart.items) || []).filter((i) => i.variant_id !== gift);
    }
    // the cart after Add to cart: existing lines + the ticked books whose chosen variant is not in the cart yet
    resulting() {
      const items = this.cartLines().map((i) => ({ handle: String(i.handle || '').toLowerCase(), line: Number(i.original_line_price || 0), qty: i.quantity || 1 }));
      const haveV = {};
      this.cartLines().forEach((i) => { haveV[String(i.variant_id)] = true; });
      const ticked = [];
      this.sel.forEach((h) => {
        const c = this.cards.find((x) => x.handle === h); const v = c && this.variantOf(c);
        if (!v) return;
        ticked.push({ handle: h, id: String(v.id), p: Number(v.p), inCart: !!haveV[String(v.id)] });
        if (!haveV[String(v.id)]) items.push({ handle: h, line: Number(v.p), qty: 1 });
      });
      return { items, ticked };
    }
    // what the engine gives for two books of this page (shown as a muted hint while 0 or 1 book is ticked); cached per format
    hintPct(g) {
      const key = this.fmt;
      this._hint = this._hint || {};
      if (this._hint[key] !== undefined) return this._hint[key];
      let pct = 0;
      const two = this.cards.map((c) => ({ c, v: this.variantOf(c) })).filter((x) => x.v).slice(0, 2);
      if (two.length === 2) {
        try {
          const items = two.map((x) => ({ handle: x.c.handle, line: Number(x.v.p), qty: 1 }));
          const full = items[0].line + items[1].line;
          const q = g.quote(items, two.map((x) => x.c.handle).join(','));
          if (q && full > q.total) pct = Math.round((1 - q.total / full) * 100);
        } catch (e) { pct = 0; }
      }
      this._hint[key] = pct;
      return pct;
    }
    // lowest % any book line of the resulting cart gets with the quote's codes (quote.pct comes from the engine); 0 if a book line gets nothing
    tierOf(quote, items, g) {
      if (!quote || !quote.pct) return 0;
      const books = (g && Array.isArray(g.books)) ? g.books : null;
      const hs = items.map((i) => i.handle).filter((h, k, a) => a.indexOf(h) === k && (!books || books.indexOf(h) !== -1));
      if (!hs.length) return 0;
      return Math.min.apply(null, hs.map((h) => Number(quote.pct[h] || 0)));
    }
    label(tpl, vars) { let s = tpl || ''; Object.keys(vars).forEach((k) => { s = s.replace('{' + k + '}', vars[k]); }); return s; }
    render() {
      // books with no variant in this format drop out of the selection
      this.sel = this.sel.filter((h) => { const c = this.cards.find((x) => x.handle === h); return c && this.variantOf(c); });
      const n = this.sel.length;
      const g = this.engine();
      const cartMode = !!this.cart && this.cartLines().length > 0;
      const foreign = !!(this.cart && g && typeof g.isOurs === 'function' && (this.cart.discount_codes || []).some((d) => d.applicable && !g.isOurs(d.code)));
      const res = this.resulting();
      let quote = null;
      // a price is only shown when the cart is known, the engine is there and no code of the shopper's own is in the cart
      if (n && g && this.cart && !foreign && !this._goCart) { try { quote = g.quote(res.items, this.sel.join(',')); } catch (e) { quote = null; } }
      // every item's `line` is already a line total (cart lines: original_line_price; ticked books: the unit price, quantity 1)
      const full = res.items.reduce((a, i) => a + i.line, 0);
      const distinct = res.items.map((i) => i.handle).filter((h, k, a) => a.indexOf(h) === k);
      this.querySelectorAll('[data-format]').forEach((b) => {
        const on = b.getAttribute('data-format') === this.fmt;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.cards.forEach((c) => {
        const v = this.variantOf(c);
        const list = this.variants(c);
        const on = this.sel.indexOf(c.handle) !== -1;
        c.el.classList.toggle('is-selected', on);
        c.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.btn.disabled = !v;
        c.btn.textContent = !v ? this.getAttribute('data-unavailable-label') : (on ? this.getAttribute('data-added-label') : this.getAttribute('data-add-label'));
        // edition picker only when the product has several variants for the chosen format; rebuilt only when the list changes
        if (list.length > 1) {
          const sig = this.fmt + '|' + list.map((x) => x.t).join('|');
          const cur = v ? list.indexOf(v) : 0;
          if (c.sig !== sig) {
            c.sig = sig;
            c.select.innerHTML = '';
            list.forEach((x, i) => { const o = document.createElement('option'); o.value = String(i); o.textContent = x.t || ''; c.select.appendChild(o); });
          }
          c.select.value = String(cur);
          c.select.hidden = false;
        } else { c.select.hidden = true; c.sig = ''; }
        if (!v) { c.price.textContent = ''; c.old.hidden = true; return; }
        const sameHandle = res.items.filter((i) => i.handle === c.handle).length === 1;
        if (on && quote && sameHandle && quote.lines && quote.lines[c.handle] !== undefined && quote.lines[c.handle] < Number(v.p)) {
          c.price.textContent = this.money(quote.lines[c.handle]); c.price.classList.add('is-new');
          c.old.textContent = this.money(Number(v.p)); c.old.hidden = false;
        } else {
          c.price.textContent = this.money(Number(v.p)); c.price.classList.remove('is-new'); c.old.hidden = true;
        }
      });
      // tier (2 Nov 2026, "Any 5 books: 20%"): the % EVERY book of the resulting cart really gets from the engine's codes (the lowest book line),
      // so it is 15 or 20, never a blended number. 0 = no discount unlocked yet (fewer than 2 books, or no quote).
      const tier = this.tierOf(quote, res.items, g);
      // ladder: honest about what the cart will really get
      const lvl = n === 0 ? -1 : (quote && distinct.length >= 5 && tier >= 20 ? 2 : (distinct.length >= 2 ? 1 : 0));
      this.querySelectorAll('.cr-step').forEach((s, i) => s.classList.toggle('is-on', i === lvl));
      const fill = this.q('[data-ladder-fill]');
      if (fill) fill.style.width = lvl === 2 ? '100%' : (lvl === 1 ? '55%' : (lvl === 0 ? '12%' : '0%'));
      // bar
      this.q('[data-count]').textContent = n === 1 ? this.getAttribute('data-count-one') : this.label(this.getAttribute('data-count-many'), { n: n });
      const tot = this.q('[data-total]');
      const sv = this.q('[data-save]');
      const nudge = this.q('[data-nudge]');
      tot.classList.remove('is-noprice');
      nudge.classList.remove('is-good');
      if (n === 0) {
        tot.hidden = true; sv.textContent = '';
        nudge.textContent = this.getAttribute('data-nudge-none');
      } else if (!quote) {
        // cart not read yet / unreadable / own discount code / engine missing: no number we cannot stand behind
        tot.hidden = false; tot.classList.add('is-noprice'); tot.textContent = (this.cart === undefined && g) ? '' : this.getAttribute('data-no-price'); sv.textContent = '';
        nudge.textContent = '';
      } else {
        tot.hidden = false;
        tot.textContent = (cartMode ? this.getAttribute('data-cart-total-label') + ' ' : '') + this.money(quote.total);
        const save = full - quote.total;
        if (save > 0) { const s = document.createElement('s'); s.textContent = this.money(full); tot.appendChild(s); }
        sv.textContent = save > 0 ? this.label(this.getAttribute('data-nudge-saving'), { saving: this.money(save) }) : '';
        // 2 Nov 2026 pre-launch: 2-4 different books on the lower tier -> "Add N more book(s) for 20% off every book." (N = 5 - different books
        // in the resulting cart). The tier is the engine's quote (tierOf), no new maths. Gone once every book is at 20% (5+ books or a 20% set).
        const books = (g && Array.isArray(g.books)) ? g.books : null;
        const nBooks = distinct.filter((h) => !books || books.indexOf(h) !== -1).length;
        const more = 5 - nBooks;
        const moreTpl = more === 1 ? this.getAttribute('data-nudge-more-one') : this.getAttribute('data-nudge-more');
        if (distinct.length <= 1) nudge.textContent = this.getAttribute('data-nudge-one');
        else if (nBooks >= 2 && more >= 1 && tier > 0 && tier < 20 && moreTpl) nudge.textContent = this.label(moreTpl, { n: more });
        else nudge.textContent = cartMode ? this.getAttribute('data-cart-includes') : '';
      }
      // save badge next to the count (2 Nov 2026): hidden until a discount is unlocked, then the tier the engine's quote really reached for every
      // book: "Save 15%" (2-4 books), "Save 20%" (5+ books, or a smaller cart that really gets 20% on every book, e.g. the 4 guides).
      // Hidden whenever the price itself is hidden (shopper's own code, engine missing, cart unread). No hint before that.
      const pill = this.q('[data-pill]');
      if (pill) {
        const priceVisible = !!(g && this.cart && !foreign && !this._goCart);
        const pct = priceVisible && n && quote && distinct.length >= 2 ? tier : 0;
        pill.hidden = !(pct > 0);
        pill.classList.remove('is-hint');
        if (pct > 0) this.q('[data-pill-t]').textContent = this.label(this.getAttribute('data-pill-text') || 'Save {pct}%', { pct: pct });
      }
      this.quote = quote;
      this.addBtn.disabled = (n === 0 && !this._goCart) || this._busy;
    }
    showError(msg) { const e = this.q('[data-error]'); e.textContent = msg || ''; e.hidden = !msg; }
    addToCart() {
      const res = this.resulting();
      if (!this.sel.length || this._busy) return;
      const btn = this.addBtn;
      const ids = []; const handles = [];
      res.ticked.forEach((t) => { ids.push(t.id); handles.push(t.handle); });
      const g = window.__crSheetsGift;
      const queue = window.__crCartQueue;
      const okJ = (r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); };
      const hdr = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      const getCart = () => fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(okJ);
      const noteOf = (cart) => String((cart && cart.attributes && cart.attributes.cr_offer_added) || '').split(',').filter((x) => x && x !== '1');
      this._busy = true; this.showError('');
      btn.disabled = true; btn.textContent = this.getAttribute('data-adding-label');
      const fail = (err) => {
        if (window.console) console.warn('[cr-bundle] add failed', err);
        this._busy = false;
        if (err && err.discountFail) {
          // the books ARE in the cart; only the discount check failed: same wording as the pair card, and a way on to the cart
          this._goCart = true;
          btn.textContent = this.getAttribute('data-go-cart-label') || 'Go to cart';
          this.showError(this.getAttribute('data-discount-error'));
          btn.disabled = false;
          this.loadCart(); // the books are in the cart now: re-read it so the page shows the real total
          return;
        }
        btn.textContent = this.addLabel; this.render();
        this.showError((err && err.refused && err.message) ? err.message : this.getAttribute('data-error-text'));
      };
      if (typeof queue !== 'function' || !g || typeof g.run !== 'function') { fail(new Error('cart helper missing')); return; }
      queue(() => getCart().then((cart) => {
        // same VARIANT only counts as already in the cart (a digital copy is not the paperback)
        const have = {};
        (cart.items || []).forEach((i) => { have[String(i.variant_id)] = true; });
        const add = []; const added = [];
        ids.forEach((id, k) => { if (!have[id]) { add.push({ id: Number(id), quantity: 1 }); added.push(handles[k]); } });
        const list = noteOf(cart);
        added.forEach((h) => { if (list.indexOf(h) === -1) list.push(h); });
        const step = add.length
          ? fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: hdr, body: JSON.stringify({ items: add }) }).then((r) => {
              if (!r.ok) return r.json().then((j) => { const e = new Error((j && (j.description || j.message)) || 'add failed'); e.refused = true; throw e; });
              return r.json();
            })
          : Promise.resolve(null);
        return step.then(() => (added.length ? fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: hdr, body: JSON.stringify({ attributes: { cr_offer_added: list.join(',') } }) }).then(okJ)
          .catch((e) => { if (window.console) console.warn('[cr-bundle] note not saved', e); }) : null));
      }).then(() => {
        // apply the engine's codes now, then check the cart total equals what the engine says (retry like the pair card does)
        let tries = 0;
        const attempt = () => {
          tries++;
          return Promise.resolve(g.run()).catch(() => {}).then(getCart).then((c2) => {
            const its = (c2.items || []).filter((i) => i.variant_id !== g.gift).map((i) => ({ handle: String(i.handle || '').toLowerCase(), line: Number(i.original_line_price || 0), qty: i.quantity || 1 }));
            const want = g.quote(its, noteOf(c2).join(',')).total;
            const foreign = (c2.discount_codes || []).some((d) => d.applicable && !g.isOurs(d.code));
            if (c2.total_price > want && !foreign && tries < 3) return new Promise((r) => setTimeout(r, 700 * tries)).then(attempt);
            if (c2.total_price > want && !foreign) { const e = new Error('discount code did not apply'); e.discountFail = true; throw e; }
          });
        };
        return attempt();
      })).then(() => { setTimeout(() => { window.location.href = this.cartUrl; }, 120); }).catch(fail);
    }
  });
}
